import { Component, OnInit, Input } from '@angular/core';
import { Category, Product } from 'src/app/_models';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/_services';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-product-price',
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.css']
})
export class ProductPriceComponent implements OnInit {

  @Input() product : Product;
  @Input() promoCategory : Category;
  @Input() detail : boolean;

  constructor(
    public translate : TranslateService,
    public utils : UtilsService,
    public dom  : DomSanitizer 
  ) {
    this.detail = false;
   }

  ngOnInit() {

  }

}
